/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ButtonUp } from '../img/button-up.svg';
import { ReactComponent as ButtonDown } from '../img/button-down.svg';
import { questions } from '../../../constants/fpQuestionObj';

const Step03Ranking = ({
  stepData,
  ranking,
  setRanking,
  itemType,
  step,
  globalCategory,
}) => {
  const { t } = useTranslation('');

  useEffect(() => {
    if (itemType === 'expenses' && !ranking) {
      const data =
        globalCategory === 'daily_life'
          ? { necessity: 100 }
          : globalCategory === 'lifestyle_experiences'
            ? { purpose: 50, happiness: 50 }
            : { purpose: 50, necessity: 100 };
      setRanking(data);
    } else if (itemType === 'incomes' && !ranking) {
      setRanking({ probability: 50 });
    }
  }, []);

  const stepPoint =
    itemType === 'expenses'
      ? globalCategory === 'daily_life'
        ? ['necessity']
        : globalCategory === 'lifestyle_experiences'
          ? ['purpose', 'happiness']
          : ['purpose', 'necessity']
      : ['probability'];

  const currentFlow =
    globalCategory === 'giving_legacy'
      ? Object.entries(questions?.[globalCategory]?.[stepPoint[step]])
      : Object.entries(questions[stepPoint[step]]);

  const pointObj =
    itemType === 'expenses'
      ? globalCategory === 'daily_life'
        ? { necessity: [0, 50, 100] }
        : globalCategory === 'lifestyle_experiences'
          ? { purpose: [0, 50, 100], happiness: [0, 50, 100] }
          : { purpose: [0, 50, 100], necessity: [0, 100] }
      : { probability: [0, 25, 50, 75, 100] };

  const handleUp = () => {
    const use = stepPoint[step];
    const current = ranking?.[use];
    if (current === pointObj[use].at(-1)) return;
    const position = pointObj[use].indexOf(current);
    setRanking({ ...ranking, [use]: pointObj[use][position + 1] });
  };

  const handleDown = () => {
    const use = stepPoint[step];
    const current = ranking?.[use];
    if (current === pointObj[use].at(0)) return;
    const position = pointObj[use].indexOf(current);
    setRanking({ ...ranking, [use]: pointObj[use][position - 1] });
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowUp') {
        handleUp();
      } else if (event.key === 'ArrowDown') {
        handleDown();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [ranking, step]);

  return (
    <div className="stageitem-point">
      <h1 className="item-point-title">{t(stepData[step])}</h1>
      <div className="stageitem-center-wrapper">
        <div></div>
        <div className="ranking-wrapper">
          {currentFlow.reverse().map(([value, label]) => {
            return (
              <React.Fragment key={value}>
                {ranking?.[stepPoint[step]] === +value ? (
                  <div className="item-point point">
                    <div className="selected-dot" />
                    <div>{t(label)}</div>
                  </div>
                ) : (
                  <div className="blank-wrapper">
                    <div className="blank-text">{t(label)}</div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        <div className="controls-btn-wrapper">
          <span>{t('Use cursor')}</span>
          <div onClick={handleUp} className="controls-btn-up">
            <ButtonUp />
          </div>
          <div onClick={handleDown} className="controls-btn-down">
            <ButtonDown />
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Step03Ranking;

Step03Ranking.propTypes = {
  stepData: PropTypes.array,
  ranking: PropTypes.object,
  setRanking: PropTypes.func,
  itemType: PropTypes.string,
  step: PropTypes.number,
  globalCategory: PropTypes.string,
};
